<template>
  <div>
    <b-tabs content-class="mt-3" v-model="tabIndex" lazy>
      <b-tab
        v-for="(sub_scenario, index) in this.scenario.sub_scenarios"
        :key="index"
        :title="sub_scenario.name"
      >
        <b-card-text>
          <add-position
            :sub_scenario="sub_scenario"
            :indexSubScenario="index"
            @agregar="renderizar('sub_scenario' + index)"
          ></add-position>
          <sub-scenario-cargo
            :sub_scenario="sub_scenario"
            :ref="'sub_scenario' + index"
            :indexSubScenario="index"
          ></sub-scenario-cargo>
        </b-card-text>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import subScenarioCargo from "./sub-scenario-cargo.vue";
import AddPosition from "./add-position.vue";
import { mapState } from "vuex";
export default {
  components: { subScenarioCargo, AddPosition },
  name: "sub-scenario",
  data() {
    return {
      tabIndex: 0,
    };
  },
  computed: {
    ...mapState("modScenarios", [
      "scenario",
      "scenarios",
      "scenarioselected",
      "loading",
      "loadingLineDeals",
      "error",
      "message",
      "history",
    ]),
  },
  methods: {
    renderizar(ref) {
      this.$refs[ref][0].renderizar();
    },
  },
};
</script>

<style>
.nav {
  flex-wrap: nowrap !important;
  overflow: auto !important;
  white-space: nowrap !important;
  overflow-y: hidden !important;
}

.nav-tabs {
  color: #546e7a !important;
  border-bottom: none !important;
}

.nav-tabs .nav-link {
  color: #546e7a;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
}

.nav-link.active {
  color: #5d5fef !important;
  border-bottom: 3px solid #5d5fef !important;
  margin-top: 0%;
}
</style>